module.exports = __webpack_public_path__ + "static/puzzle-e3133411251a51975f879dceef49fbbe.jpg";